import React from 'react';
import { Box, Button } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { useTranslate } from 'react-admin';
import { CRM_COLORS, CRM_RADIUS } from '../../../theme/crmColors';
import { MetabaseGroupByTypeDate } from '../../../utils/metabase';

const OPTIONS: MetabaseGroupByTypeDate[] = ['hours', 'day', 'month'];

const useStyles = makeStyles(() => ({
    group: {
        display: 'inline-flex',
        gap: 2,
        padding: 3,
        borderRadius: CRM_RADIUS.control,
        backgroundColor: CRM_COLORS.segmented,
    },
    button: {
        height: 34,
        borderRadius: 6,
        fontSize: '0.875rem',
        fontWeight: 500,
        color: CRM_COLORS.text.secondary,
        padding: '0 14px',
        minWidth: 0,
    },
    selected: {
        backgroundColor: CRM_COLORS.surface,
        color: CRM_COLORS.secondary,
        fontWeight: 600,
        boxShadow: '0 1px 2px rgba(9, 43, 75, 0.12)',
        '&:hover': {
            backgroundColor: CRM_COLORS.surface,
        },
    },
}));

interface GranularityToggleProps {
    value: MetabaseGroupByTypeDate;
    onChange: (value: MetabaseGroupByTypeDate) => void;
}

const GranularityToggle: React.FC<GranularityToggleProps> = ({ value, onChange }) => {
    const classes = useStyles();
    const translate = useTranslate();

    return (
        <Box className={classes.group}>
            {OPTIONS.map((option) => (
                <Button
                    key={option}
                    data-testid={`granularity-${option}`}
                    aria-pressed={value === option}
                    className={`${classes.button} ${value === option ? classes.selected : ''}`}
                    onClick={() => onChange(option)}
                >
                    {translate(`app.dashboard.granularity.${option}`)}
                </Button>
            ))}
        </Box>
    );
};

export default GranularityToggle;
